// Mind map keys: Tab grows a subtopic, Enter a sibling; the new topic opens for typing.
import type { NodeId } from '@vellum/core';
import { app } from './app.ts';

export function mindMapKey(key: string, id: NodeId): boolean {
  const n = app.doc.get(id);
  if (!n || (!n.mindParent && !n.mindMap) || app.readOnly) return false;
  if (key !== 'Tab' && key !== 'Enter') return false;
  const next = key === 'Tab' ? app.editor.addMindTopic(id) : app.editor.addMindSibling(id);
  app.editor.setSelection([next]);
  app.setUI({ editingTextId: next });
  return true;
}
